import { createSelector } from 'reselect'

const getTags = ({ tags }) => tags.records
const getexpenseCategoryGlCodes = ({ tags }) => tags.tagMappingsData

const tagsSelectors = {
  getTagOptions: createSelector([getTags], (tags) => {
    if (!tags.length) {
      return []
    }

    return tags.map((tag) => {
      return { label: tag.value.name, value: tag.value }
    })
  }),
  getexpenseCategoryGlCodes: createSelector([getexpenseCategoryGlCodes], (tagMappingsData) => {
    let finalTagGlCodes = {}
    if (!tagMappingsData.length) {
      return {}
    }
    tagMappingsData.map((tag) => {
      return (finalTagGlCodes[tag?.value?.name] = tag?.tagMappings?.glcode)
    })
    return finalTagGlCodes
  }),
  getGlCodeExpenseCategories: createSelector([getexpenseCategoryGlCodes], (tagMappingsData) => {
    let finalTagGlExpenseCategories = {}
    if (!tagMappingsData.length) {
      return {}
    }
    tagMappingsData.map((tag) => {
      const updateTag = { ...tag }
      delete updateTag['tagMappings']
      return tag?.tagMappings?.glcode.map((tagGlcodeObj) => {
        return (finalTagGlExpenseCategories[tagGlcodeObj?.value?.name] = [updateTag])
      })
    })
    return finalTagGlExpenseCategories
  }),
}
// Test
export default tagsSelectors
